import React from 'react';
import { Box, Divider } from '@material-ui/core';

import BangTinhDiem from '../../../containers/QCV/CauHinhHeThong/BangTinhDiem';
import CauHinhTaiLieuBTC from '../../../containers/QCV/CauHinhHeThong/CauHinhTaiLieuBTC';

export default function CauHinhHeThong(props) {
	return (
		<Box marginY={4}>
			<CauHinhTaiLieuBTC />
			<Divider style={{ margin: '32px 0' }} />
			<BangTinhDiem type={props.type} />
		</Box>
	);
}